import { createI18n } from 'vue-i18n';
import ko from './ko.json';
import en from './en.json';

export default createI18n({
    silentTranslationWarn: true,
    legacy:true,
    allowComposition:true,
    silentFallbackWarn: true,
    locale: window.localStorage.getItem('language'),
    fallbackLocale: 'ko',
    messages: {en, ko}
});
